import navIconBillsAndPayments from 'assets/icons/nav-icons/billsAndPayments.inline.svg';
import navNetWorth from 'assets/icons/nav-icons/netWorth.inline.svg';
import navIconClients from 'assets/icons/nav-icons/clients.inline.svg';
import navIconDashboard from 'assets/icons/nav-icons/dashboard.inline.svg';
import navIconHelp from 'assets/icons/nav-icons/help.inline.svg';
import navIconInvestments from 'assets/icons/nav-icons/investments.inline.svg';
import navIconInvoice from 'assets/icons/nav-icons/invoice.inline.svg';
import navIconMileageIcon from 'assets/icons/nav-icons/mileage.inline.svg';
import navIconNotifications from 'assets/icons/nav-icons/notifications.inline.svg';
import navIconExpenseReceipts from 'assets/icons/nav-icons/expenseReceipts.inline.svg';
import navIconPlanningTools from 'assets/icons/nav-icons/planningTools.inline.svg';
import navIconProfile from 'assets/icons/nav-icons/profile.inline.svg';
import navIconRefresh from 'assets/icons/nav-icons/refresh.inline.svg';
import navIconReports from 'assets/icons/nav-icons/reports.inline.svg';
import navIconSalesAndBilling from 'assets/icons/nav-icons/salesAndBilling.inline.svg';
import navIconSavingsGoals from 'assets/icons/nav-icons/savingsGoals.inline.svg';
import navIconSettings from 'assets/icons/nav-icons/settings.inline.svg';
import navIconSpending from 'assets/icons/nav-icons/spending.inline.svg';
import navIconSpendingPlan from 'assets/icons/nav-icons/spendingPlan.inline.svg';
import taxPlanner from 'assets/icons/nav-icons/taxPlanner.inline.svg';
import navIconTransactions from 'assets/icons/nav-icons/transactions.inline.svg';
import navIconWatchlist from 'assets/icons/nav-icons/watchlist.inline.svg';
import navIconCategories from 'assets/icons/settings-menu/categories.tags.settings.simplifi.inline.svg';
import navIconRecurring from 'assets/icons/settings-menu/recurring.settings.simplifi.inline.svg';
import navIconTags from 'assets/icons/tags.svg';

export {
  navNetWorth,
  navIconRecurring,
  navIconCategories,
  navIconTags,
  navIconBillsAndPayments,
  navIconClients,
  navIconDashboard,
  navIconHelp,
  navIconInvestments,
  navIconInvoice,
  navIconNotifications,
  navIconExpenseReceipts,
  navIconPlanningTools,
  navIconProfile,
  navIconRefresh,
  navIconReports,
  navIconSalesAndBilling,
  navIconSavingsGoals,
  navIconSettings,
  navIconSpending,
  navIconSpendingPlan,
  navIconTransactions,
  navIconWatchlist,
  taxPlanner,
  navIconMileageIcon,
};
